import useBlogPostsBySlugRequest from './useBlogPostsBySlugRequest'

export { useBlogPostsBySlugRequest }
